import { combineReducers } from "redux";
import chatReducer from "./chatReducer.js";

export default combineReducers({
  chatReducer,
});
